import './index.css';
import { useState, useEffect } from 'react';

function CalendarGrid({ time, posts, expandedBool, SetSelectedScheduledDate }) {
    const [selectedDate, setSelectedDate] = useState(null);

    const navigateToIdea = (id) => {
        window.location.href = '/ideas?id=' + id;
    }

    const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

    const getStartDayOfWeek = (month, year) => {
        const startDay = new Date(year, month, 1).getDay();
        return (startDay === 0) ? 6 : startDay - 1; // Adjust to make Monday the first day
    };

    useEffect(() => {
        let todayDate = document.getElementsByClassName("is-today");
        if(document.body.clientWidth<800){
            todayDate[0].scrollIntoView({behavior:'smooth'})
        }
    }, []);

    useEffect(() => {
        setSelectedDate(null);
    }, [time]);

    const today = time;
    const month = today.getMonth();
    const year = today.getFullYear();

    const daysInMonth = getDaysInMonth(month, year);
    const startDayOfWeek = getStartDayOfWeek(month, year);

    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const daysOfWeekMini = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const monthsWritten = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const days = [];

    const handleDateClick = (date) => {
        if (!expandedBool) {
            setSelectedDate(date);
            SetSelectedScheduledDate(date);
        }
    };

    // Fill in the dates of the month, starting from the first day
    for (let i = 0; i < startDayOfWeek; i++) {
        days.push(<div className='empty-item' key={`empty-${i}`}></div>);
    }
    let todayDayNumber = new Date().getDate();
    for (let i = 1; i <= daysInMonth; i++) {
        let scheduledPosts = [];
        if (posts && posts.length > 0) {
            scheduledPosts = posts.filter(post => {
                const postDate = new Date(post.date);
                return postDate.getDate() === i && postDate.getMonth() === month && postDate.getFullYear() === year;
            });
        }

        let className = expandedBool ? 'schedule-item small-text' : 'schedule-item mini-date small-text';
        if (!expandedBool && selectedDate === i) {
            className += ' selected-date';
        }
        let isToday = todayDayNumber === i;
        let isThisMonth = time.getMonth() === new Date().getMonth();
        let isThisYear = time.getFullYear() === new Date().getFullYear();
        if(isToday&&isThisMonth&&isThisYear){
            className += ' is-today';
        }
        let day = new Date(time.getFullYear(), time.getMonth(), i - 1).getDay();
        
        days.push(
            <div
                className={className}
                key={`day-${i}`}
                onClick={() => handleDateClick(i)}
            >
                <div style={{display: expandedBool ? "none" : "block"}} className='date-number'>{i}</div>
                <div style={{display: expandedBool ? "block" : "none"}} className='date-number-mobile tiny-text'>{daysOfWeekMini[day] + " " + i + " " + monthsWritten[time.getMonth()]}</div>
                {scheduledPosts.length > 0 && scheduledPosts.map(post => (
                    <div key={post.id} className='post' onClick={() => navigateToIdea(post.id)}>
                        <div className='post-title tiny-text'>
                            <img 
                                src={post.ideaType === 'post' ? '../images/linkedin.png' : '../images/blog.png'} 
                                alt={post.ideaType}
                                style={{ height: '1.5em', verticalAlign: 'middle', marginRight: '4px', marginTop:"-2px" }}
                            />
                            {post.title ? post.title : post.generatedFrom}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    let headersClass = expandedBool ? 'days-header hidden-header' : 'days-header mini-header tiny-text';
    let headers = expandedBool ? daysOfWeek.map(day => <div className='day-item' key={day}>{day}</div>) : daysOfWeekMini.map(day => <div className='day-item' key={day}>{day}</div>)
    let scheduleClassName = expandedBool ? 'schedule-container' : 'schedule-container mini-picker';

    return (
        <div>
            <div className={headersClass}>
                {headers}
            </div>
            
            <div className={scheduleClassName}>
                {days}
            </div>
        </div>
    );
}

export default CalendarGrid;
